import React from "react";

const Switch = ({ checked, onChange, disabled = false, onColor = 'bg-green-500', offColor = 'bg-red-500', ballColor = 'bg-white', className = "", children }) => {
  return (
    <div className="flex w-full items-center gap-2 cursor-pointer" onClick={() => !disabled && onChange && onChange(!checked)}>
      {children && <span className="flex items-center gap-2 flex-1 text-left">{children}</span>}
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange && onChange(!checked)}
      className={`m-auto relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${checked ? onColor : offColor} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full ${ballColor} shadow transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`}
      />
    </button>
    </div>
  );
};

export default Switch;
